import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { GetDeleteMessages } from "./messagesAPI";

export interface MessageState {
  deletemessages: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: MessageState = {
  deletemessages: [],
  status: "idle",
};

export const DeleteMessages = createAsyncThunk(
  "message/DeleteMessages",
  async (id:any) => {
    const response = await GetDeleteMessages(id);
    return response;
  }
);

export const DeleteMessageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(DeleteMessages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(DeleteMessages.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(DeleteMessages.fulfilled, (state, action) => {
        state.status = "idle";
        state.deletemessages =  action.payload;
      });
  },
});

export const {} = DeleteMessageSlice.actions;

export const selectDeletedMessages = (state: RootState) => {
  return state.Deletemessage.deletemessages;
};

export default DeleteMessageSlice.reducer;
